module.exports = __webpack_public_path__ + "img/002.69d41502.jpg";